import './climatechange.less'

import {FunctionComponent, Image, m, Picture} from '@codeurs/front'
import {ImageType, LinkType, PageData, WysiwygType} from 'types'
import {Theme} from 'views/theme'
import {style} from '../../util/style'

const styles = style('climatechange', ['item'])

type ClimateChangeItemType = {
	image: ImageType
	text: WysiwygType
	link: LinkType
}

type ClimateChange = {
	nl: ClimateChangeItemType
	fr: ClimateChangeItemType
}

export const ClimateChange: FunctionComponent<
	{data: PageData} & ClimateChange
> = ({data}) => {
	return (
		<div class={styles}>
			{['fr', 'nl'].map(lang => (
				<ClimateChangeItem {...data[lang]} />
			))}
		</div>
	)
}

const ClimateChangeItem: FunctionComponent<ClimateChangeItemType> = ({
	image,
	text,
	link
}) => {
	return (
		<div class={styles.item}>
			<a href={link.url}>
				<div class={styles.item('content')}>
					<Image {...image} />
					<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
				</div>
			</a>
		</div>
	)
}
